import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

const requireCompontent = require.context(
  '@/components/global', // 需要读取的目录路径
  true, // 是否查询其子目录
  /\w+-+\w+\.vue|js|jsx$/ // 匹配基础组件的文件名的正则表达式
);

requireCompontent.keys().forEach((fileName) => {
  console.log(fileName);
  // 获取组件配置
  const componentConfig = requireCompontent(fileName);
  // 获取组件的PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  );
  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  );
});